import {all, call, fork, put, select, takeEvery} from 'bukku/shared/SagaService';
import actions from './actions';
import {errorSagaFn, requestSagaPullingFn, requestSagaPushingFn, successSagaFn} from "../helper";
import {deleto, get, patch, post, puto} from "bukku/shared/ApiService";
// import {DummyStoreSettingAPI} from "./dummy";
import {t} from "@lingui/macro";
import ListActions from 'bukku/redux/List/actions';

const successKeys = [
    actions.STORE_CP_READ_ORDERS_SUCCESS,
    actions.STORE_CP_DELETE_ORDER_SUCCESS,
    actions.STORE_CP_UPDATE_ORDER_SUCCESS,
    actions.STORE_CP_READ_CATEGORIES_SUCCESS,
    actions.STORE_CP_CREATE_CATEGORY_SUCCESS,
    actions.STORE_CP_READ_CATEGORY_SUCCESS,
    actions.STORE_CP_UPDATE_CATEGORY_SUCCESS,
    actions.STORE_CP_UPDATE_CATEGORY_FEATURED_SUCCESS,
    actions.STORE_CP_UPDATE_CATEGORY_HIDDEN_SUCCESS,
    actions.STORE_CP_DELETE_CATEGORY_SUCCESS,
    actions.STORE_CP_UPDATE_CATEGORY_POSITION_SUCCESS,
    actions.STORE_CP_READ_PAGE_LIST_SUCCESS,
    actions.STORE_CP_CREATE_PAGE_SUCCESS,
    actions.STORE_CP_READ_PAGE_SUCCESS,
    actions.STORE_CP_UPDATE_PAGE_SUCCESS,
    actions.STORE_CP_DELETE_PAGE_SUCCESS,
    actions.STORE_CP_READ_COUPON_LIST_SUCCESS,
    actions.STORE_CP_CREATE_COUPON_SUCCESS,
    actions.STORE_CP_READ_COUPON_SUCCESS,
    actions.STORE_CP_UPDATE_COUPON_SUCCESS,
    actions.STORE_CP_DELETE_COUPON_SUCCESS,
];
const errorKeys = [
    actions.STORE_CP_READ_ORDERS_ERROR,
    actions.STORE_CP_DELETE_ORDER_ERROR,
    actions.STORE_CP_UPDATE_ORDER_ERROR,
    actions.STORE_CP_READ_CATEGORIES_ERROR,
    actions.STORE_CP_CREATE_CATEGORY_ERROR,
    actions.STORE_CP_READ_CATEGORY_ERROR,
    actions.STORE_CP_UPDATE_CATEGORY_ERROR,
    actions.STORE_CP_UPDATE_CATEGORY_FEATURED_ERROR,
    actions.STORE_CP_UPDATE_CATEGORY_HIDDEN_ERROR,
    actions.STORE_CP_DELETE_CATEGORY_ERROR,
    actions.STORE_CP_UPDATE_CATEGORY_POSITION_ERROR,
    actions.STORE_CP_READ_PAGE_LIST_ERROR,
    actions.STORE_CP_CREATE_PAGE_ERROR,
    actions.STORE_CP_READ_PAGE_ERROR,
    actions.STORE_CP_UPDATE_PAGE_ERROR,
    actions.STORE_CP_DELETE_PAGE_ERROR,
    actions.STORE_CP_READ_COUPON_LIST_ERROR,
    actions.STORE_CP_CREATE_COUPON_ERROR,
    actions.STORE_CP_READ_COUPON_ERROR,
    actions.STORE_CP_UPDATE_COUPON_ERROR,
    actions.STORE_CP_DELETE_COUPON_ERROR,
    actions.STORE_CP_FETCH_CATEGORY_PRODUCT_DETAILS_ERROR,
];

const getSuccessMsg = action => {
    switch (action.type) {
        case actions.STORE_CP_DELETE_ORDER_SUCCESS:
            return t`The order is deleted.`;
        case actions.STORE_CP_UPDATE_ORDER_SUCCESS:
            return t`The order is updated.`;
        case actions.STORE_CP_CREATE_CATEGORY_SUCCESS:
            return t`The category is created successfully.`;
        case actions.STORE_CP_UPDATE_CATEGORY_SUCCESS:
            return t`The category is updated successfully.`;
        case actions.STORE_CP_DELETE_CATEGORY_SUCCESS:
            return t`The category is deleted.`;
        case actions.STORE_CP_CREATE_PAGE_SUCCESS:
            return t`The content page is created.`;
        case actions.STORE_CP_UPDATE_PAGE_SUCCESS:
            return t`The content page is updated successfully.`;
        case actions.STORE_CP_DELETE_PAGE_SUCCESS:
            return t`The content page is deleted.`;
        case actions.STORE_CP_CREATE_COUPON_SUCCESS:
            return t`The coupon is created successfully.`;
        case actions.STORE_CP_UPDATE_COUPON_SUCCESS:
            return t`The coupon is updated successfully.`;
        case actions.STORE_CP_DELETE_COUPON_SUCCESS:
            return t`The coupon is deleted.`;
        default:
            return null;
    }
};

function* readOrderListRequest() {
    yield takeEvery(actions.STORE_CP_READ_ORDERS_REQUEST, function* (action, context) {
        yield requestSagaPullingFn(action,
            function* ({ request }) {
                const response = yield call(get, '/orders', request, context);
                const data = yield response.data;

                yield put({
                    type: actions.STORE_CP_READ_ORDERS_SUCCESS,
                    orders: data.orders,
                    pagination: data.paging,
                });
            },
        );
    });
}

function* deleteOrderRequest() {
    yield takeEvery(actions.STORE_CP_DELETE_ORDER_REQUEST, function* (action, context) {
        yield requestSagaPushingFn(action,
            function* ({ id }) {
                yield call(deleto, `/orders/${id}`, null, context);
                yield put({
                    type: actions.STORE_CP_DELETE_ORDER_SUCCESS,
                });
            },
        );
    });
}
function* updateOrderRequest() {
    yield takeEvery(actions.STORE_CP_UPDATE_ORDER_REQUEST, function* (action, context) {
        yield requestSagaPushingFn(action,
            function* ({ id, request }) {
                yield call(patch, `/orders/${id}`, request, context);
                yield put({
                    type: actions.STORE_CP_UPDATE_ORDER_SUCCESS,
                });
            },
        );
    });
}

function* readCategoryListRequest() {
    yield takeEvery(actions.STORE_CP_READ_CATEGORIES_REQUEST, function* (action, context) {
        yield requestSagaPullingFn(action,
            function* ({ request }) {
                const response = yield call(get, '/categories', request, context);
                const data = yield response.data;

                yield put({
                    type: actions.STORE_CP_READ_CATEGORIES_SUCCESS,
                    categories: data,
                });
            },
        );
    });
}
function* createCategoryRequest() {
    yield takeEvery(actions.STORE_CP_CREATE_CATEGORY_REQUEST, function* (action, context) {
        yield requestSagaPushingFn(action,
            function* ({ request }) {
                const response = yield call(post, '/categories', request, context);
                const data = yield response.data;
                yield put({
                    type: actions.STORE_CP_CREATE_CATEGORY_SUCCESS,
                    createCategoryResult: data,
                });
            },
        );
    });
}

function* readCategoryRequest() {
    yield takeEvery(actions.STORE_CP_READ_CATEGORY_REQUEST, function* (action, context) {
        yield requestSagaPullingFn(action,
            function* ({ id }) {
                const response = yield call(get, `/categories/${id}`, null, context);
                const data = yield response.data;

                yield put({
                    type: actions.STORE_CP_READ_CATEGORY_SUCCESS,
                    category: data,
                });

                // yield readProductList();

                // const products = yield select(state => state.List.productList);
                // const productIds = products.filter(p => p.is_selling && p.type === 'product').map(p => p.id);

                // // Full Product Detail List
                // const productDetailList = yield readProductDetailsByChunks(productIds, 'SALE');
                // yield put({
                //     type: ListActions.LIST_REPLACE_PRODUCT_DETAIL_LIST,
                //     productDetailList,
                // });
            },
        );
    });
}
function* updateCategoryRequest() {
    yield takeEvery(actions.STORE_CP_UPDATE_CATEGORY_REQUEST, function* (action, context) {
        yield requestSagaPushingFn(action,
            function* ({ id, request }) {
                yield call(puto, `/categories/${id}`, request, context);
                yield put({
                    type: actions.STORE_CP_UPDATE_CATEGORY_SUCCESS,
                });
            },
        );
    });
}

function* updateCategoryFeaturedRequest() {
    yield takeEvery(actions.STORE_CP_UPDATE_CATEGORY_FEATURED_REQUEST, function* (action, context) {
        yield requestSagaPushingFn(action,
            function* ({ id, value }) {
                const request = {is_featured: value};
                if (request.is_featured)
                    request.is_hidden = false;

                yield call(patch, `/categories/${id}`, request, context);
                yield put({
                    type: actions.STORE_CP_UPDATE_CATEGORY_FEATURED_SUCCESS,
                });
            },
        );
    });
}
function* updateCategoryHiddenRequest() {
    yield takeEvery(actions.STORE_CP_UPDATE_CATEGORY_HIDDEN_REQUEST, function* (action, context) {
        yield requestSagaPushingFn(action,
            function* ({ id, value }) {
                const request = {is_hidden: value};
                if (request.is_hidden)
                    request.is_feature = false;

                yield call(patch, `/categories/${id}`, request, context);

                yield put({
                    type: actions.STORE_CP_UPDATE_CATEGORY_HIDDEN_SUCCESS,
                });
            },
        );
    });
}

function* updateCategoryPositionRequest() {
    yield takeEvery(actions.STORE_CP_UPDATE_CATEGORY_POSITION_REQUEST, function* (action, context) {
        yield requestSagaPushingFn(action,
            function* () {
                const { StoreSetting } = yield select();
                const { categories } = StoreSetting;

                const request = {
                    category_ids: categories.map(category => category.id),
                };

                yield call(puto, '/categories/positions', request, context);

                yield put({
                    type: actions.STORE_CP_UPDATE_CATEGORY_POSITION_SUCCESS,
                });
            },
        );
    });
}

function* deleteCategoryRequest() {
    yield takeEvery(actions.STORE_CP_DELETE_CATEGORY_REQUEST, function* (action, context) {
        yield requestSagaPushingFn(action,
            function* ({ id }) {
                yield call(deleto, `/categories/${id}`, null, context);
                yield put({
                    type: actions.STORE_CP_DELETE_CATEGORY_SUCCESS,
                });
            },
        );
    });
}

function* readPageListRequest() {
    yield takeEvery(actions.STORE_CP_READ_PAGE_LIST_REQUEST, function* (action) {
        yield requestSagaPullingFn(action,
            function* ({ request }) {
                const response = yield call(get, '/store/pages', request);
                const data = yield response.data;

                yield put({
                    type: actions.STORE_CP_READ_PAGE_LIST_SUCCESS,
                    pages: data.pages,
                    pagination: data.paging,
                });
            },
        );
    });
}

function* readPageRequest() {
    yield takeEvery(actions.STORE_CP_READ_PAGE_REQUEST, function* (action) {
        yield requestSagaPullingFn(action,
            function* ({ id }) {
                const response = yield call(get, `/store/pages/${id}`);
                const data = yield response.data;

                yield put({
                    type: actions.STORE_CP_READ_PAGE_SUCCESS,
                    page: data,
                });
            },
        );
    });
}

function* updatePageRequest() {
    yield takeEvery(actions.STORE_CP_UPDATE_PAGE_REQUEST, function* (action) {
        yield requestSagaPushingFn(action,
            function* ({ id, request }) {
                yield call(puto, `/store/pages/${id}`, request);
                yield put({
                    type: actions.STORE_CP_UPDATE_PAGE_SUCCESS,
                });
            },
        );
    });
}

function* deletePageRequest() {
    yield takeEvery(actions.STORE_CP_DELETE_PAGE_REQUEST, function* (action) {
        yield requestSagaPushingFn(action,
            function* ({ id }) {
                yield call(deleto, `/store/pages/${id}`);
                yield put({
                    type: actions.STORE_CP_DELETE_PAGE_SUCCESS,
                });
            },
        );
    });
}

function* readCouponListRequest() {
    yield takeEvery(actions.STORE_CP_READ_COUPON_LIST_REQUEST, function* (action) {
        yield requestSagaPullingFn(action,
            function* ({ request }) {
                const response = yield call(get, '/store/coupons', request);
                const data = yield response.data;
                yield put({
                    type: actions.STORE_CP_READ_COUPON_LIST_SUCCESS,
                    coupons: data.coupons,
                    pagination: data.paging,
                });
            },
        );
    });
}
function* createCouponRequest() {
    yield takeEvery(actions.STORE_CP_CREATE_COUPON_REQUEST, function* (action) {
        yield requestSagaPushingFn(action,
            function* ({ request }) {
                const response = yield call(post, '/store/coupons', request);
                const data = yield response.data;
                yield put({
                    type: actions.STORE_CP_CREATE_COUPON_SUCCESS,
                    createCouponResult: data.coupon,
                });
            },
        );
    });
}
function* readCouponRequest() {
    yield takeEvery(actions.STORE_CP_READ_COUPON_REQUEST, function* (action) {
        yield requestSagaPullingFn(action,
            function* ({ id }) {
                const response = yield call(get, `/store/coupons/${id}`);
                const data = yield response.data;

                yield put({
                    type: actions.STORE_CP_READ_COUPON_SUCCESS,
                    coupon: data.coupon,
                });
            },
        );
    });
}
function* updateCouponRequest() {
    yield takeEvery(actions.STORE_CP_UPDATE_COUPON_REQUEST, function* (action) {
        yield requestSagaPushingFn(action,
            function* ({ id, request }) {
                yield call(puto, `/store/coupons/${id}`, request);
                yield put({
                    type: actions.STORE_CP_UPDATE_COUPON_SUCCESS,
                });
            },
        );
    });
}

function* deleteCouponRequest() {
    yield takeEvery(actions.STORE_CP_DELETE_COUPON_REQUEST, function* (action) {
        yield requestSagaPushingFn(action,
            function* ({ id }) {
                yield call(deleto, `/store/coupons/${id}`);
                yield put({
                    type: actions.STORE_CP_DELETE_COUPON_SUCCESS,
                });
            },
        );
    });
}

function* fetchCategoryProductDetailsRequest() {
    yield takeEvery(actions.STORE_CP_FETCH_CATEGORY_PRODUCT_DETAILS_REQUEST, function* (action) {
        yield requestSagaPullingFn(action,
            function* ({ productIds }) {
                const existingList = yield select(state => state.List.productDetailList);
                const existingIds = new Set(existingList.map(p => p.id));
                const idsToFetch = productIds.filter(id => !existingIds.has(id));

                if (!idsToFetch.length)
                    return;

                const response = yield call(post, '/v2/lists', {
                    lists: ['product_detail_list'],
                    params: {
                        product_detail_list: {
                            product_ids: idsToFetch,
                            type: 'SALE',
                        },
                    },
                });
                const data = yield response.data;
                const productDetailList = data.product_detail_list?.items || [];

                yield put({
                    type: ListActions.LIST_MERGE_PRODUCT_DETAIL_LIST,
                    productDetailList,
                });
            },
            false,
        );
    });
}

export default function* rootSaga() {
    yield all([
        fork(successSagaFn(successKeys, getSuccessMsg)),
        fork(errorSagaFn(errorKeys)),
        fork(readOrderListRequest),
        fork(deleteOrderRequest),
        fork(updateOrderRequest),
        fork(readCategoryListRequest),
        fork(fetchCategoryProductDetailsRequest),
        fork(createCategoryRequest),
        fork(readCategoryRequest),
        fork(updateCategoryRequest),
        fork(updateCategoryFeaturedRequest),
        fork(updateCategoryHiddenRequest),
        fork(deleteCategoryRequest),
        fork(updateCategoryPositionRequest),
        fork(readPageListRequest),
        fork(readPageRequest),
        fork(updatePageRequest),
        fork(deletePageRequest),
        fork(readCouponListRequest),
        fork(createCouponRequest),
        fork(readCouponRequest),
        fork(updateCouponRequest),
        fork(deleteCouponRequest),
    ]);
}
